"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillTeams = exports.Team = void 0;
class Team {
    constructor() {
        this._count = 0;
        this._score = 0;
        this._players = [];
        this._playersByPos = new Map();
    }
    players() {
        return this._playersByPos;
    }
    addPlayer(pos, player) {
        const players = this._playersByPos.get(pos) || [];
        players.push(player);
        this._playersByPos.set(pos, players);
        this._players.push(player);
        this._players.sort((a, b) => {
            return a.score - b.score;
        });
        this._score += player.score;
        this._count++;
    }
    avgScore() {
        return this._score / this._count;
    }
    medScore() {
        const medIdx = Math.floor(this._count / 2);
        return this._players[medIdx].score;
    }
    count() {
        return this._count;
    }
}
exports.Team = Team;
const teamsCompare = (a, b) => {
    const diffByCount = a.count() - b.count();
    if (diffByCount !== 0) {
        return diffByCount;
    }
    const diffByAvg = a.avgScore() - b.avgScore();
    if (diffByAvg !== 0) {
        return diffByAvg;
    }
    const diffByMed = a.medScore() - b.medScore();
    if (diffByMed !== 0) {
        return diffByMed;
    }
    return 0;
};
const fixDefinition = (definition, players) => {
    players.forEach(pl => {
        pl.positions.forEach(pos => {
            const availablePos = definition.map(d => d.pos);
            if (pos === "" || availablePos.includes(pos)) {
                return;
            }
            definition.push({ pos, num: 1 });
        });
    });
    return definition;
};
const fixPlayers = (allPositions, players) => {
    return players.map(p => {
        if (p.positions.filter(pos => pos !== "").length === 0) {
            p.positions = allPositions;
        }
        return p;
    }).sort((a, b) => {
        return b.score - a.score;
    });
};
const fillTeams = (teams, players, definition) => {
    const teamDef = fixDefinition(definition, players);
    const allPositions = teamDef.map(d => d.pos);
    let availablePlayers = fixPlayers(allPositions, players);
    while (availablePlayers) {
        for (const def of teamDef) {
            for (let i = 0; i < def.num; i++) {
                for (const team of teams) {
                    if (availablePlayers.length === 0) {
                        return teams;
                    }
                    const playerIdx = availablePlayers.findIndex(p => {
                        return p.positions.includes(def.pos);
                    });
                    if (playerIdx < 0) {
                        break;
                    }
                    const p = availablePlayers.splice(playerIdx, 1).pop();
                    team.addPlayer(def.pos, p);
                }
                teams.sort(teamsCompare);
            }
        }
    }
    return teams;
};
exports.fillTeams = fillTeams;
